import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './ie.css';
import './assets/css/oronaline.css';
import './i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import swConfig from './swConfig';

ReactDOM.render(<App />, document.getElementById('root'));

// Registro de Service Worker
serviceWorker.register(swConfig);

navigator.serviceWorker.addEventListener("message", (event) => {

	  console.log('Mensaje recibido en el Service Worker:', event.data);
	  if (event.data && event.data.type === 'SKIP_WAITING') {
		  
		  console.log("skip");
	  }

});